// @flow
import { get } from 'lodash';
import type { Action, ContextState } from '../../../types';

// ------------------------------------
// Constants
// ------------------------------------
const OPEN_MODAL = 'modals.OPEN_MODAL';
const CLOSE_ACTIVE_MODAL = 'modals.CLOSE_ACTIVE_MODAL';

// ------------------------------------
// Actions
// ------------------------------------
export const openModal = (modalName: string, data?: Object = {}) => ({
  type: OPEN_MODAL,
  modalName,
  data,
});

export const closeActiveModal = () => ({
  type: CLOSE_ACTIVE_MODAL,
});

// The open modal is saved with the store and comes back after a reload: it waits for the active clinic,
// which every modal of the app works on (the appointment form read clinic.rooms on undefined: Bugsnag 6adb75c0)
export const visibleModal = (context: Object) => (get(context, ['clinics', 'activeClinic']) ? get(context, ['modals', 'active']) : false);

// The patient a financial modal works on: the one it was opened for. The modal is app-wide and stays open when the page
// changes under it (the browser's or Android's Back), and the agenda's route has no patient id: the service's Salvar
// went to /patients/NaN/services/:id (Bugsnag 6ae09ee5). The route's id only for a modal opened without one.
export const modalPatientId = (state: Object, ownProps: Object): number => parseInt(
  get(state, ['context', 'modals', 'data', 'patientId']) || get(ownProps, ['match', 'params', 'id']),
  10,
);

export const actions = {
  openModal,
  closeActiveModal,
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function modalsReducer (state: ContextState, action: Action): ContextState {
  switch (action.type) {
    case OPEN_MODAL:
      return state
        .setIn(['modals', 'active'], action.modalName)
        .setIn(['modals', 'data'], action.data);
    case CLOSE_ACTIVE_MODAL:
      return state
        .setIn(['modals', 'active'], false)
        .setIn(['modals', 'data'], null);
    default:
      return state;
  }
}
